/** Agreement package helpers: authenticated PDF blobs + shared Schedule A / compensation views. */
import React from 'react';
import api from '../../lib/api';

export async function pdfBlobUrl(endpoint) {
  const r = await fetch(`${api.baseURL}${endpoint}`, { headers: api.getHeaders() });
  if (!r.ok) { let d = `HTTP ${r.status}`; try { d = (await r.json()).detail || d; } catch { /* binary */ } throw new Error(d); }
  return URL.createObjectURL(await r.blob());
}

export async function openPdf(endpoint) {
  const url = await pdfBlobUrl(endpoint);
  const a = document.createElement('a');
  a.href = url; a.target = '_blank'; a.rel = 'noopener';
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

const UNIT = { bps: (a) => `${a} bps`, percent_of_revenue: (a) => `${a}%`, per_transaction: (a) => `$${Number(a).toFixed(4)} / txn`, flat_monthly: (a) => `$${Number(a).toFixed(2)} / month`, flat_annual: (a) => `$${Number(a).toFixed(2)} / year` };
const fmt = (i) => (i.amount == null ? '—' : (UNIT[i.unit] || ((a) => a))(i.amount));

export function ScheduleATables({ scheduleA }) {
  if (!scheduleA?.length) return <p className="text-sm text-muted-foreground">No Schedule A is part of this agreement.</p>;
  return scheduleA.map((s) => (
    <div key={s.platform} className="space-y-1" data-testid={`schedule-a-${s.platform}`}>
      <p className="text-sm font-semibold">{s.label}</p>
      <p className="text-xs text-muted-foreground">Effective {s.effective_from || '—'}</p>
      <table className="w-full text-sm"><thead><tr className="border-b text-left text-xs uppercase text-muted-foreground"><th className="py-1">Fee</th><th>Category</th><th className="text-right">Your cost</th></tr></thead>
        <tbody>{s.items.map((i) => <tr key={i.item_id || i.fee_code} className="border-b last:border-0"><td className="py-1.5">{i.label || i.fee_code}</td><td>{i.category || '—'}</td><td className="text-right font-mono">{fmt(i)}</td></tr>)}</tbody></table>
    </div>
  ));
}

export function CompensationSummary({ comp, label }) {
  if (!comp || !Object.keys(comp).length) return <p className="text-sm text-muted-foreground">Compensation is set by MSC and is not part of this agreement.</p>;
  return (
    <div className="space-y-1 text-sm" data-testid="package-compensation">
      <p>Plan: <b>{label}</b></p>
      {comp.split_percent != null && <p>Revenue share: <b>{comp.split_percent}%</b></p>}
      {comp.tiers?.length > 0 && <ul className="list-disc pl-5">{comp.tiers.map((t) => <li key={t.label}>{t.label}: {t.display_range} → {t.split_percent}%</li>)}</ul>}
      {comp.upline && <p>Upline: {comp.upline}</p>}
    </div>
  );
}
